function ensureTag(tagName, selector, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement(tagName);
    document.head.appendChild(element);
  }

  Object.keys(attributes).forEach(key => {
    element.setAttribute(key, attributes[key]);
  });
}

function removeManagedStructuredData() {
  const existing = document.querySelector('#managed-structured-data');
  if (existing) {
    existing.remove();
  }
}

export function setSeoMeta(options) {
  const meta = options || {};

  document.title = meta.title || 'JL Consultorías';

  ensureTag('meta', 'meta[name="description"]', {
    name: 'description',
    content: meta.description || ''
  });
  ensureTag('meta', 'meta[property="og:title"]', {
    property: 'og:title',
    content: meta.title || 'JL Consultorías'
  });
  ensureTag('meta', 'meta[property="og:description"]', {
    property: 'og:description',
    content: meta.description || ''
  });
  ensureTag('meta', 'meta[property="og:type"]', {
    property: 'og:type',
    content: meta.type || 'website'
  });
  ensureTag('meta', 'meta[property="og:url"]', {
    property: 'og:url',
    content: meta.url || window.location.href
  });
  ensureTag('meta', 'meta[property="og:image"]', {
    property: 'og:image',
    content: meta.image || `${window.location.origin}/img/logo-jl.png`
  });
  ensureTag('meta', 'meta[name="twitter:card"]', {
    name: 'twitter:card',
    content: 'summary_large_image'
  });
  ensureTag('meta', 'meta[name="twitter:title"]', {
    name: 'twitter:title',
    content: meta.title || 'JL Consultorías'
  });
  ensureTag('meta', 'meta[name="twitter:description"]', {
    name: 'twitter:description',
    content: meta.description || ''
  });
  ensureTag('link', 'link[rel="canonical"]', {
    rel: 'canonical',
    href: meta.url || window.location.href
  });

  removeManagedStructuredData();

  if (meta.structuredData) {
    const script = document.createElement('script');
    script.id = 'managed-structured-data';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(meta.structuredData);
    document.head.appendChild(script);
  }
}
